<template>
  <div class="tags-cloud">
    <div class="tags-cloud__header">
      <h4 class="tags-cloud__title"> Теги </h4>
      <div class="tags-cloud__help" @click="tagsHelpPopupOpened = true"></div>
      <div class="tags-cloud__chevron" :class="{'chevron-up': cloudShown}" @click="cloudShown = !cloudShown"></div>
    </div>
    <div class="tags-cloud__list" v-if="cloudShown">
      <div
        v-for="(tag, index) in tagsList"
        :key="tag.id"
        class="tags-cloud__list-item"
        :style="{
          'border-color': `#${tag.selected ? tag.meta.fill_color : tag.meta.text_color}`,
          'background-color': `#${tag.selected ? tag.meta.fill_color : 'fff'}`,
          'color': `#${tag.selected ? tag.meta.text_color : '000'}`
        }"
        @click="selectTag(tag, index)"
      >
        <div class="tags-cloud__list-dot" :style="{'background-color': `#${tag.meta.text_color}`}"></div>
        {{ tag.field_value }}
      </div>
    </div>
    <Modal :opened="tagsHelpPopupOpened" @close="tagsHelpPopupOpened = false">
      <div>
        <h1>Теги</h1>
        <i><b>Теги</b> - ключевые слова, позволяющие упорядочить наших пользователей на Платформе. <br>
          Вы можете не только добавлять пользователей в Избранное, но и присваивать каждому пользователю ключевые слова или фразы, которые наиболее полно его описывают.<br>
          Используйте теги как дополнительные фильтры, находите нужных вам пользователей легко и быстро.</i>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from "@/components/UI/Modal.vue";
import {mapGetters, mapActions} from "vuex";
export default {
    name: "UserSearchTagsCloud",
    components: {
      Modal,
    },
    data() {
        return {
          cloudShown: false,
          tagsHelpPopupOpened: false,
          userTagsList: [],
        };
    },
    props: {
      selectedTags: {
        type: Array,
      },
      tags: {
        type: Array,
      },
    },
    computed: {
        ...mapGetters('data', [
            'getRegistryItems',
        ]),
        tagsList() {
            return this.userTagsList;
        },
    },
    watch: {
      selectedTags: {
        handler(v) {
          this.userTagsList = [];
          this.userTagsList = this.getRegistryItems('user_tags');
          for(let i = 0; i < this.userTagsList.length; i++) {
            this.userTagsList[i].selected = false;
          }
          if (v.length) {
            this.cloudShown = true;
            this.userTagsList.forEach((tag, index) => {
              v.forEach((selectedTag) => {
                if (tag.id == selectedTag.id) {
                  this.userTagsList.splice(index, 1, {...tag, selected: true});
                }
              });
            });
          }
        },
        immediate: true,
      },
    },
    methods: {
      selectTag(tag, index) {
        if(this.userTagsList[index].selected !== undefined) {
          this.userTagsList[index].selected = !this.userTagsList[index].selected;
        } else {
          this.userTagsList[index].selected = true;
        }
        this.$emit("selectTag", tag);
      },
      ...mapActions('data', [
          'loadRegistryItems',
      ]),
    },
    async mounted() {
      await this.loadRegistryItems({ type: 'user_tags', withMeta: true });
      this.userTagsList = this.getRegistryItems('user_tags');
      if (this.selectedTags.length) {
        this.userTagsList.forEach((tag, index) => {
          this.selectedTags.forEach((selectedTag) => {
            if (tag.id == selectedTag.id) {
              this.userTagsList.splice(index, 1, {...tag, selected: true});
            }
          });
        });
      }
    },
};

</script>
<style lang="scss">
@import '~@/styles/rem';
@import "~@/styles/variables";
@import "~@/styles/mixins";

.tags-cloud {

  &__list {
    padding-top: rem(16);
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: rem(14);
    font-family: 'Montserrat';
    font-size: rem(14);
    font-style: normal;
    font-weight: 600;
    line-height: rem(22);

      @include on-mobile {
          padding-top: mrem(16);
          gap: mrem(14);
          font-size: mrem(14);
          line-height: mrem(22);
      }

    &-dot {
      width: rem(6);
      height: rem(6);
      border-radius: rem(3);

        @include on-mobile {
            width: mrem(6);
            height: mrem(6);
            border-radius: mrem(3);
        }
    }

    &-item {
      display: flex;
      align-items: center;
      gap: rem(8);
      padding: rem(6) rem(16) rem(6) rem(8);
      border-radius: rem(30) rem(60) rem(60) rem(30);
      border-width: rem(1);
      border-style: solid;
      cursor: pointer;

        @include on-mobile {
            gap: mrem(8);
            padding: mrem(6) mrem(16) mrem(6) mrem(8);
            border-radius: mrem(30) mrem(60) mrem(60) mrem(30);
            border-width: mrem(1);
        }
    }
  }

  &__help {
    width: rem(18);
    height: rem(18);
    margin: rem(-3) rem(2) 0 rem(3);
    @include user-search-help(black);
    background-size: cover;
    vertical-align: super;
    cursor: pointer;

      @include on-mobile {
          width: mrem(18);
          height: mrem(18);
          margin: mrem(-3) mrem(2) 0 mrem(3);
      }
  }

  &__header {
    display: flex;
    margin-top: rem(16);

      @include on-mobile {
          margin-top: mrem(16);
      }
  }

  &__chevron {
    width: rem(24);
    height: rem(24);
    background: url("~@/assets/images/portfolio/chevron.svg") no-repeat center center;
    background-size: contain;
    cursor: pointer;

      @include on-mobile {
          width: mrem(24);
          height: mrem(24);
      }
  }
  &__title {
    color: #2A2626;
    margin: 0;
    font-family: "Montserrat", sans-serif;
    font-size: rem(18);
    font-style: normal;
    font-weight: 700;
    line-height: rem(24);
    cursor: pointer;

      @include on-mobile {
          font-size: mrem(18);
          line-height: mrem(24);
      }
  }
}

.chevron-up {
  transform: rotate(180deg);
}
</style>
